import { Method, RawAxiosRequestHeaders } from "axios";

import { axiosInstance } from "../model";

export const handleFetch = async <R, T>(
  url: string,
  method: Method,
  data?: T,
  headers?: RawAxiosRequestHeaders,
): Promise<R> => {
  try {
    const response = await axiosInstance({
      method,
      url,
      data: data || {},
      headers: headers || { "Content-Type": "application/json" },
    });

    return response.data as R;
  } catch (error) {
    const apiError = error?.response?.data;

    // Backend returned a structured error ({ ok: false, error: "..." })
    if (apiError && typeof apiError === "object" && "error" in apiError) {
      return apiError as R;
    }

    const status = error?.response?.status;

    throw new Error(
      status ? `Request failed with status ${status}` : error?.message || "Network error",
    );
  }
};
